import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import * as CONFIG from "./_config";
import ls from "local-storage";

toast.configure();
const axios = require("axios");

const isAlmichsMarket = CONFIG.DATA.RSA_SUBDOMAIN === "almichsmarket";

function OverlayContent({children}) {
  return (
    <div className="content">
      <div className="overlay">
        <div  className={`overlay-content ${
        isAlmichsMarket ? "custom-search" : ""
      }`}>{children}</div>
      </div>
    </div>
  )
}

class Weeklyadsall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      WeeklyAds: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.GetWeeklyAds();
      ls.set("redirectTo", window.location.href);
    }
  }

  componentDidMount() {
    this.GetWeeklyAds();
    if (isAlmichsMarket) {
      const overlayContent = document.getElementById("ideal-circular-view-container");
      if (overlayContent) {
        overlayContent.innerHTML = `
          <ideal-circular-view
            embedded-mode="true"
            brand="almichsmarket"
          ></ideal-circular-view>
        `;
        const script = document.createElement("script");
        script.src = "https://component.ideal.sale/ideal-circular-view.js";
        overlayContent.appendChild(script);
      }
    }


    ls.set("redirectTo", window.location.href);
  }

  convertDate(dt) {
    //var dt = '/Date(1567494000000+0000)/'
    var dt2 = dt.substr(dt.indexOf("(") + 1);
    var dt3 = dt2.substr(0, dt2.indexOf("+"));
    var d = new Date(Number(dt3));
    //console.log(dt, dt3, d);
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = d.getFullYear();
    var dt4 = mm + "/" + dd + "/" + yyyy;
    return dt4;
  }

  GetWeeklyAds() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    const data = new FormData();
    data.append("method", "POST");
    data.append("ClientDbName", CONFIG.DATA.RSA_CLIENT_DB_NAME);
    data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
    data.append("Token", "");
    var apiurl = "";
    console.log(CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID);
    if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
      console.log("if");
      // data.append('apiurl', `https://clientsupport.rsaamerica.com/Services/SSWebRestApi.svc/GetWeeklyAdsByCustomer`);
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetWeeklyAdsByCustomer`;
      data.append("ClientStoreGroupId", CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID);
    } else {
      console.log("else");
      //data.append("apiurl","https://clientsupport.rsaamerica.com/Services/SSWebRestApi.svc/GetWeeklyAdsByStore");
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetWeeklyAdsByStore`;
    }
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: "clientsupport" },
      })
      .then((res) => {
        this.setState({
          WeeklyAds: res.data.WeeklyAds === null ? [] : res.data.WeeklyAds,
        });
        // console.log("WeeklyAds", this.state.WeeklyAds);
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  renderWeeklyAds() {
    if (isAlmichsMarket) {
      return <OverlayContent>
        <div id="ideal-circular-view-container"></div>
      </OverlayContent>
    }
    
    var gallerylink = "weekly-ads"; // CONFIG.DATA.THEME == 2 && CONFIG.DATA.WEEKLY_AD_FULL_SCREEN === false ? 'weekly-ads-gallery':'weekly-ads';
    const weeklyAdsData = this.state.WeeklyAds;
    const weeklyAdsList = Array.isArray(weeklyAdsData)
      ? weeklyAdsData
      : weeklyAdsData && typeof weeklyAdsData === "object"
      ? Object.values(weeklyAdsData)
      : [];

    if (weeklyAdsList.length > 0) {
      return weeklyAdsList.map((WeeklyAd, index) => (
        <div
          key={index}
          className="wpb_column vc_column_container vc_col-sm-4"
          style={{ minWidth: "390px" }}
        >
          <div className="vc_column-inner">
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <h3>{WeeklyAd.STORENAME}</h3>
                  <h3>
                    Weekly ad
                    <div>
                      from{" "}
                      {this.convertDate(
                        WeeklyAd.VALIDFROMDATE
                      )}
                    </div>
                    <div>
                      &nbsp;&nbsp;&nbsp;&nbsp;to{" "}
                      {this.convertDate(
                        WeeklyAd.EXPIRESON
                      )}
                    </div>
                  </h3>
                </div>
              </div>
              <div className="wpb_single_image wpb_content_element vc_align_center">
                <figure className="wpb_wrapper vc_figure">
                  <Link
                    to={
                      "/" +
                      gallerylink +
                      "/" +
                      WeeklyAd.STOREID +
                      "/" +
                      WeeklyAd.STORENAME.replace(
                        /\s/g,
                        "-"
                      )
                        .replace(/\//g, "_")
                        .toLowerCase()
                    }
                    className="vc_single_image-wrapper   vc_box_border_grey"
                  >
                    <img
                      width={1575}
                      height={1500}
                      src={WeeklyAd.PDFFILENAME}
                      className="vc_single_image-img attachment-full"
                      alt={
                        WeeklyAd.STORENAME +
                        " at " +
                        WeeklyAd.ADDRESSLINE1
                      }
                    />
                  </Link>
                </figure>
              </div>
            </div>
          </div>
        </div>
      ))
    }

    if (weeklyAdsData) {
      return (
        <OverlayContent>
          <div style={{height: "200px"}}></div>
          <h3>No records found</h3>
          <div style={{height: "100px"}}></div>
        </OverlayContent>
      )
    }

    return (
      <OverlayContent>
        <div style={{height: "100px"}}></div>
        <img
          style={{maxWidth: "none"}}
          src="/assets/images/loading.gif"
          alt="Loading..."
        />
      </OverlayContent>
    )
  }

  render() {
    // HR:2021-06-02
    // hide gallery view for all, as most of clients are requesting to have full screen Ads visibility.
    return (
      <div>
        <div className="main-container default-page mt-2 pt-2">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Weekly Ads</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/weekly-ads">Weekly Ads</a>
                        </li>
                        <li>
                          <span className="active">
                            {CONFIG.DATA.RSA_CLIENT_APP_NAME}
                          </span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1 className="entry-title">Weekly Ads</h1>
                </header>
                <div className="breadcrumbs d-none d-md-block ">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span> Weekly Ads</span>
                </div>
              </div>
            </div>
          )}

          <div className="clearfix" />
            <div className="container">
              {isAlmichsMarket ? (
                <div className="col-xs-12 ">
                  <article
                    id="post-8027"
                    className="post-8027 page type-page status-publish hentry"
                    style={{ minHeight: "500px" }}
                  >
                    <div className="entry-content mt-5">
                      <div className="wpb_row vc_row-fluid">{this.renderWeeklyAds()}</div>
                    </div>
                  </article>
                </div>
              ) : (
                <div className="row" style={{ minHeight: "600px" }}>
                  <div className="col-xs-12">
                    <div className="page-content default-page">
                      <article
                        id="post-8027"
                        className="post-8027 page type-page status-publish hentry"
                      >
                        <div className="entry-content mt-5">
                          <div className="vc_row wpb_row vc_row-fluid">
                            <div className="row-container">
                              <div className="wpb_row vc_row-fluid">
                                {this.renderWeeklyAds()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              )}
            </div>


        </div>
      </div>
    );
  }
}
export default Weeklyadsall;
